import dayjs from "dayjs";
import { getLoginToken, getTgId } from "./initConfig/utils";
import { md5 } from "./md5";
import { v4 } from "uuid";

// build的时候区分预发布和正式环境
export const HTTP_PREFIX = process.env.REACT_APP_HTTP_PREFIX;
export const WS_PREFIX = process.env.REACT_APP_WS_PREFIX;
export const TRON_HTTP_PREFIX = process.env.REACT_APP_TRON_HTTP_PREFIX;
export const TRON_WS_PREFIX = process.env.REACT_APP_TRON_WS_PREFIX;

function getLoginParams() {
  const tgId = getTgId();
  const uuid = v4();
  const timestamp = dayjs().unix();
  const token = getLoginToken();
  const randString = `${uuid}${tgId ?? ""}${token ?? ""}${timestamp}`;
  const md5String = md5(randString, timestamp);
  return {
    loginToken: token || "",
    loginPlatform: "website",
    requestId: uuid,
    at: timestamp.toString(),
    v: md5String,
  };
}

/**
 * @name birdEye Kline
 */
// export function queryKLineByBirdEye({
//   token,
//   fromTime,
//   endTime,
//   gap = "5m",
// }: {
//   token: string;
//   fromTime: number;
//   endTime: number;
//   gap?: string;
// }): Promise<any> {
//   const reqOptions = {
//     method: "GET",
//     headers: {
//       accept: "application/json",
//       "x-chain": "solana",
//       "X-API-KEY": "b248535661de4c70b84ef65fb0d5f536",
//     },
//   };
//   const url = `https://public-api.birdeye.so/defi/ohlcv?address=${token}&type=${gap}&time_from=${fromTime}&time_to=${endTime}`;
//   return fetch(url, reqOptions);
// }

/**
 * @name 获取dev交易记录
 */
export function queryDevOptions(params: { chain: string; token: string }) {
  const tgId = getTgId();
  return fetch(`${HTTP_PREFIX}/api/chainToken/queryDevActions`, {
    method: "post",
    body: JSON.stringify({ ...params, tgId }),
    headers: {
      "Content-Type": "application/json",
      ...getLoginParams(),
    },
  });
}

export function queryTronKlineData(params: {
  token: string;
  count: number;
  interval:
    | "seconds"
    | "minutes"
    | "hours"
    | "days"
    | "weeks"
    | "months"
    | "years";
  from: number;
  to: number;
}) {
  return fetch(`${TRON_HTTP_PREFIX}/api/token/queryTokenOHLC`, {
    method: "post",
    body: JSON.stringify({ ...params }),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

/**
 * @name 交易历史
 */
export function queryTradeHistory(
  chain: string,
  params: {
    //交易类型
    type?: "buy" | "sell";
    //两个一起传过滤
    chain?: string;
    address?: string;
    nextId?: number;
  }
) {
  const tgId = getTgId();
  return fetch(
    chain.toLowerCase() === "tron"
      ? `${TRON_HTTP_PREFIX}/api/order/history`
      : `${HTTP_PREFIX}/api/order/history`,
    {
      method: "post",
      body: JSON.stringify({ ...params, tgId }),
      headers: {
        "Content-Type": "application/json",
        ...getLoginParams(),
      },
    }
  );
}

/**
 * @name 自己的k线数据
 */
export function querySptKline(params: {
  // "1s" | "1m" | "5m" | "15m" | "30m" | "1H" | "4H" | "1D" | "1W"
  type: string;
  time_from: number;
  time_to: number;
  address: string;
}) {
  return fetch(`${HTTP_PREFIX}/api/common/ohlcv2`, {
    method: "post",
    body: JSON.stringify({ ...params }),
    headers: {
      "Time-Zone": (
        0 -
        dayjs.tz().toDate().getTimezoneOffset() / 60
      ).toString(),
      "Content-Type": "application/json",
    },
  });
}

/**
 * @name 获取推送交易历史数据
 */
export function queryOnlineTrade(params: { token?: string; owner?: string }) {
  return fetch(`${HTTP_PREFIX}/api/common/queryOnlineTrade`, {
    method: "post",
    body: JSON.stringify({ ...params, tgId: getTgId() }),
    headers: {
      ...getLoginParams(),
      "Content-Type": "application/json",
    },
  });
}

/**
 * @name 获取推送交易历史数据
 */
export function getTokenSymbol(params: { token: string }) {
  return fetch(`${HTTP_PREFIX}/api/chainToken/queryTokenInfo`, {
    method: "post",
    body: JSON.stringify({ ...params, tgId: getTgId() }),
    headers: {
      ...getLoginParams(),
      "Content-Type": "application/json",
    },
  });
}
